import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { setToken } from "../api";

export default function Navbar({ user, setUser }) {

  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const navbarRef = useRef();

  const logout = () => {
    localStorage.removeItem("token");
    setToken(null);
    setUser(null);
    nav("/login");
  };

  // 🔥 CLOSE ON OUTSIDE CLICK
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (navbarRef.current && !navbarRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // 🔥 CLOSE ON LINK CLICK
  const handleLinkClick = () => {
    setOpen(false);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark" ref={navbarRef}>
      <div className="container-fluid">

        {/* BRAND */}
        <Link className="navbar-brand" to="/" onClick={handleLinkClick}>
          Logistic Advanced
        </Link>

        {/* TOGGLE */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setOpen(!open)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* MENU */}
        <div className={`collapse navbar-collapse ${open ? "show" : ""}`}>

          <ul className="navbar-nav me-auto">

            {user && (
              <>
                <li className="nav-item">
                  <Link className="nav-link" to="/" onClick={handleLinkClick}>
                    Dashboard
                  </Link>
                </li>

                <li className="nav-item">
                  <Link className="nav-link" to="/load-form" onClick={handleLinkClick}>
                    Create Load
                  </Link>
                </li>

                <li className="nav-item">
                  <Link className="nav-link" to="/loads" onClick={handleLinkClick}>
                    Loads
                  </Link>
                </li>

                <li className="nav-item">
                  <Link className="nav-link" to="/reports" onClick={handleLinkClick}>
                    Reports
                  </Link>
                </li>

                {user.role === "admin" && (
                  <>
                    <li className="nav-item">
                      <Link className="nav-link" to="/product-types" onClick={handleLinkClick}>
                        Product Types
                      </Link>
                    </li>

                    <li className="nav-item">
                      <Link className="nav-link" to="/employees" onClick={handleLinkClick}>
                        Employees
                      </Link>
                    </li>

                    <li className="nav-item">
                      <Link className="nav-link" to="/customers" onClick={handleLinkClick}>
                        Customers
                      </Link>
                    </li>

                    <li className="nav-item">
                      <Link
                        className="nav-link text-warning"
                        to="/admin/employee-wages"
                        onClick={handleLinkClick}
                      >
                        Employee Wages
                      </Link>
                    </li>

                    <li className="nav-item">
                      <Link className="nav-link" to="/register" onClick={handleLinkClick}>
                        Register User
                      </Link>
                    </li>
                  </>
                )}
              </>
            )}

          </ul>

          {/* RIGHT SIDE */}
          <ul className="navbar-nav ms-auto">

            {!user && (
              <li className="nav-item">
                <Link className="nav-link" to="/login" onClick={handleLinkClick}>
                  Login
                </Link>
              </li>
            )}

            {user && (
              <>
                <li className="nav-item">
                  <span className="nav-link">
                    Hello, {user.name} ({user.role})
                  </span>
                </li>

                <li className="nav-item">
                  <button
                    className="btn btn-sm btn-outline-light mt-2 mt-lg-0"
                    onClick={() => {
                      logout();
                      handleLinkClick();
                    }}
                  >
                    Logout
                  </button>
                </li>
              </>
            )}

          </ul>

        </div>
      </div>
    </nav>
  );
}